<!-- ══════════════════════════════════════════════════════════════════
     Ask Me — Figma nodes 83-12972 / 125-36116 / 125-36162
     ══════════════════════════════════════════════════════════════════ -->

<!-- ── Top Navigation ──────────────────────────────────────────── -->
<header class="am-nav">
  <div class="am-nav__card">
    <div class="am-nav__left">
      <button class="am-nav__brand" (click)="handleLogoClick()" type="button">
        <span class="am-nav__brand-name">Deloitte Ascend™</span>
      </button>
      <span class="am-nav__divider"></span>
      <span class="am-nav__product">Test AI</span>
    </div>
    <button class="am-nav__close" (click)="closeDialog()" type="button" aria-label="Close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M18.34 5.66L5.66 18.34M5.66 5.66L18.34 18.34" stroke="#007680" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>
</header>

<!-- ── Main ─────────────────────────────────────────────────────── -->
<main class="am-main" [class.am-main--chat]="chatStarted">

  <!-- ══ LANDING ══ -->
  @if (!chatStarted) {
    <div class="am-landing">
      <img class="am-landing__avatar" src="assets/images/askMe.png" alt="AI Assistant" />

      <div class="am-landing__welcome">
        <p class="am-landing__hello">Hello, {{ userName }}</p>
        <h1 class="am-landing__headline">How can I help you today?</h1>
      </div>

      <div class="am-input-wrap">
        <div class="am-input-border">
          <div class="am-input-inner">
            <input
              #inputRef
              type="text"
              class="am-input"
              [(ngModel)]="userQuestion"
              [placeholder]="inputPlaceholder"
              (keyup.enter)="onAsk()"
              (input)="onInputChange($event)"
            />
            @if (userQuestion?.length) {
              <button class="am-send" (click)="onAsk()" type="button" tabindex="-1" aria-label="Send">
                <img src="assets/images/askMe-send.svg" class="am-send__icon" alt="Send" />
              </button>
            }
          </div>
        </div>
      </div>

      <div class="am-chips">
        <div class="am-chips__row">
          @for (suggestion of suggestedQuestions.slice(0, 3); track suggestion) {
            <button class="am-chip" type="button" (click)="onSuggestionClick(suggestion)">
              {{ suggestion }}
            </button>
          }
        </div>
        <div class="am-chips__row">
          @for (suggestion of suggestedQuestions.slice(3, 6); track suggestion) {
            <button class="am-chip" type="button" (click)="onSuggestionClick(suggestion)">
              {{ suggestion }}
            </button>
          }
        </div>
      </div>
    </div>
  }

  <!-- ══ CHAT ══ -->
  @else {
    <div class="am-chat">
      <div class="am-chat__history" #chatHistory>
        <app-chat-message
          *ngFor="let message of messages"
          [text]="message.text"
          [sender]="message.sender"
          [timestamp]="message.timestamp"
        ></app-chat-message>
      </div>

      <footer class="am-chat__footer">
        <div class="am-input-wrap">
          <div class="am-input-border">
            <div class="am-input-inner">
              <input
                #inputRef
                type="text"
                class="am-input"
                [(ngModel)]="userQuestion"
                [placeholder]="inputPlaceholder"
                (keyup.enter)="onAsk()"
                (input)="onInputChange($event)"
                [disabled]="isLoading"
              />
              <div class="am-send-area">
                @if (isLoading) {
                  <div class="am-loader">
                    <div class="am-loader__ring"></div>
                  </div>
                } @else if (userQuestion?.length) {
                  <button class="am-send" (click)="onAsk()" type="button" tabindex="-1" aria-label="Send">
                    <img src="assets/images/askMe-send.svg" class="am-send__icon" alt="Send" />
                  </button>
                }
              </div>
            </div>
          </div>
        </div>

        <div class="am-session">
          <div class="am-session__group">
            <span class="am-session__muted">Session started:</span>
            <span class="am-session__value">{{ sessionStartedTime | date : "MMM dd, yyyy, h:mm a" }}</span>
          </div>
          <div class="am-session__group">
            <button class="am-session__reset" type="button" (click)="reset()">Click Here</button>
            <span class="am-session__muted">to reset the session</span>
          </div>
        </div>
      </footer>
    </div>
  }

</main>
